var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { calcDataVencimento, formatForPayload, paddingCpfCnpj, parse, } from "../util/utilitarios";
import httpClient from "../infra/httpClient";
import httpClientAnistia from "../infra/httpClientAnistia";
import { toast } from "react-toastify";
export function getDataLimiteAnistia() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, error_1, errorAxios;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/buscar-data-limite";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.get(url, {
                            timeout: 300000,
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_1 = _a.sent();
                    errorAxios = error_1;
                    console.error("Ocorreu um erro na função de buscar data limite da anistia:", errorAxios.message);
                    throw new Error(errorAxios.message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function imprimiTermoAnistiaOuAvisoPagarDare(numeroAnistia, tipo) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "";
                    if (tipo === 1) {
                        url = "/imprimir-termo-anistia";
                    }
                    else if (tipo === 2) {
                        url = "/imprimir-aviso-de-debito";
                    }
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 231,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: {
                                numeroAnistia: numeroAnistia,
                                tipo: tipo,
                            },
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 300000,
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_2 = _a.sent();
                    throw new Error("Não foi possível gera a anistia. Entre em contato com o suporte.");
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function gerarDARPDF(parcelaData) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/gerar-dar";
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 235,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: parcelaData,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 300000,
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_3 = _a.sent();
                    throw new Error("Não foi possível gerar o DAR. Entre em contato com o suporte.");
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getAnistia(renavam) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/buscar-debitos";
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 229,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: {
                                renavam: renavam,
                            },
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 300000,
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_4 = _a.sent();
                    throw new Error("Não foi possível obter as anistias." + error_4);
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function consultarAnistia(numeroDocumento) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/consultar";
                    body = {
                        numeroAnistia: numeroDocumento,
                        sistemaOrigem: 5,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 300000,
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_5 = _a.sent();
                    throw new Error("Não foi possível obter a anistias");
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function gerarAnistia(payload) {
    return __awaiter(this, void 0, Promise, function () {
        var url, body, response, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/gerar";
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 230,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: payload,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 300000,
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_6 = _a.sent();
                    console.error("Ocorreu um erro na função de gerar anistia:", error_6);
                    throw new Error("Não foi possível gerar a anistia");
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function excluiAnistia(numeroDocumento, descricaoMotivo, tipoMotivo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response, erros, responseObject, i, error_7, errorAxios;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = "/cancelar";
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 232,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: {
                                descricaoMotivo: descricaoMotivo,
                                numeroAnistia: numeroDocumento,
                                tipoMotivo: tipoMotivo,
                                usuario: "ETIPI",
                                sistemaOrigem: 5,
                            },
                        },
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 3000000,
                        })];
                case 2:
                    response = _c.sent();
                    if (response.data.status === "FALHA") {
                        erros = response;
                        responseObject = JSON.parse(erros.data.data.erros);
                        for (i = 0; i < responseObject.erros.length; i++) {
                            toast.error(responseObject.erros[i]);
                        }
                    }
                    return [2 /*return*/, response];
                case 3:
                    error_7 = _c.sent();
                    errorAxios = error_7;
                    if ((_a = errorAxios.response) === null || _a === void 0 ? void 0 : _a.data) {
                        // toast.error(`Falha: ${errorAxios.response.data?.details}`);
                        throw new Error("Falha: ".concat((_b = errorAxios.response.data) === null || _b === void 0 ? void 0 : _b.data.erros));
                    }
                    else {
                        console.log("Erro");
                    }
                    console.error(error_7);
                    throw new Error(errorAxios.message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getDebitos(payload, _token) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var url, body, response, error_8, errorAxios;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = "/consultar-debitos";
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 225,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: payload,
                        },
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClientAnistia.post(url, body, {
                            timeout: 3000000,
                        })];
                case 2:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_8 = _c.sent();
                    errorAxios = error_8;
                    if ((_a = errorAxios.response) === null || _a === void 0 ? void 0 : _a.data) {
                        throw new Error("Falha: ".concat((_b = errorAxios.response.data) === null || _b === void 0 ? void 0 : _b.details));
                    }
                    throw new Error("Não foi possível obter os débitos." + error_8);
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getBoleto(payload, accessToken) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var url, body, response, content, error_9, errorAxios;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    url = "/solicitar-codigobarras";
                    body = {
                        dataAcao: new Date().toLocaleDateString("pt-br"),
                        codigoAcao: 226,
                        sistemaEnvio: "ETIPI",
                        conteudoEnvio: {
                            protocoloDetalhe: payload,
                        },
                    };
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClient.post(url, body, {
                            timeout: 60000,
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 2:
                    response = _e.sent();
                    content = parse(((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.conteudoSaida) || "");
                    return [2 /*return*/, {
                            tokenBoleto: (_c = content === null || content === void 0 ? void 0 : content.conteudoSaida) === null || _c === void 0 ? void 0 : _c.tokenBoleto,
                            codigoBarras: content === null || content === void 0 ? void 0 : content.conteudoSaida.linhaDigitavel,
                            qrCode: content === null || content === void 0 ? void 0 : content.conteudoSaida.qrCodePix,
                        }];
                case 3:
                    error_9 = _e.sent();
                    errorAxios = error_9;
                    if (((_d = errorAxios.response) === null || _d === void 0 ? void 0 : _d.status) === 403) {
                        toast.error(errorAxios.response.data.details);
                        console.error("Falha: ".concat(errorAxios));
                    }
                    else {
                        // return "Erro";
                    }
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function generateBoleto(item, data, token) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var conteudoSaida, payload, response, error_10;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    conteudoSaida = data.conteudoSaida.conteudoSaida;
                    payload = __assign({ renavam: conteudoSaida.renavam, cpfCnpj: paddingCpfCnpj(conteudoSaida.proprietario.cpfCnpjRenavan), nomeRazaoSocial: conteudoSaida.proprietario.nome, bairro: conteudoSaida.proprietario.bairroDono, cep: conteudoSaida.proprietario.cepDono, cidade: conteudoSaida.proprietario.descricaoMunicipioDono, uf: conteudoSaida.proprietario.uf, endereco: conteudoSaida.proprietario.logradouroDono, dataVencimento: calcDataVencimento(item.dataVencimento), dataPagamento: item.dataPagamento, descricaoCota: item.descricaoCota || item.numeroParcela, valorPrincipal: formatForPayload(item.valorPrincipal), multa: formatForPayload(item.multa), juros: formatForPayload(item.juros), valorTotal: formatForPayload(item.total), codigoMunicipio: conteudoSaida.proprietario.codigoMunicipioDono, periodoReferencia: item.periodoReferencia, numeroCota: item.numeroParcela, codigoReceita: item.codigoReceita, numeroDocumento: item.numeroDocumento || 0, atualMonetario: item.atualizacao }, (!!item.isencaoLei7995 && { isencaoLei7995: item.isencaoLei7995 }));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClient.post("/gerar-boleto-dar", payload, {
                            headers: { Authorization: "Bearer ".concat(token) },
                        })];
                case 2:
                    response = _b.sent();
                    // Backend deve retornar { boletoUrl: string }
                    if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.boletoUrl) {
                        window.open(response.data.boletoUrl, "_blank", "noopener, noreferrer");
                    }
                    else {
                        toast.error("Erro ao gerar boleto: URL não retornada pelo servidor");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_10 = _b.sent();
                    console.error("[generateBoleto] - error:", error_10);
                    toast.error("Não foi possível gerar o boleto. Tente novamente.");
                    throw error_10;
                case 4: return [2 /*return*/];
            }
        });
    });
}
